import { render, staticRenderFns } from "./tdGrayIfFuture.vue?vue&type=template&id=68c96952&scoped=true"
import script from "./tdGrayIfFuture.vue?vue&type=script&lang=js"
export * from "./tdGrayIfFuture.vue?vue&type=script&lang=js"
import style0 from "./tdGrayIfFuture.vue?vue&type=style&index=0&id=68c96952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c96952",
  null
  
)

export default component.exports